export const breakpoints = {
  xs: 0,
  sm: 480,
  md: 860,
  lg: 1200,
  xl: 1700,
};

export const isSmallScreen = (currentBreakpoint: string) => {
  return breakpoints[currentBreakpoint] < breakpoints.md;
};
